import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";

export class BPMToolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
  }

  render() {
    return (
      <div className="ui-g-12">
        <pr.Toolbar style={{ backgroundColor: "light-gray" }}>
          <div className="p-toolbar-group-left">
            {/* <pr.MultiSelect
              style={
                this.props.editMode
                  ? { display: "none" }
                  : { marginRight: ".25em", float: "left" }
              }
              value={this.props.tableColumns}
              options={this.props.columnOptions}
              onChange={this.props.updateColumns}
            /> */}
            <pr.BreadCrumb
              model={this.props.menuItems}
              home={pr.getBreadcrumbMenuHome()}
              style={{ backgroundColor: "transparent", float: "left" }}
            />
            <pr.Button
              icon="pi pi-times"
              className="p-button-danger"
              style={
                this.props.editMode
                  ? { marginRight: ".25em", float: "right" }
                  : { display: "none" }
              }
              onClick={() => {
                this.props.validateChanges();
              }}
            />
            <pr.Button
              icon="pi pi-plus"
              style={
                this.props.editMode
                  ? { display: "none" }
                  : { marginRight: ".25em", float: "right" }
              }
              onClick={() => {
                this.props.runCreate();
              }}
            />
            <pr.Button
              type="button"
              style={
                this.props.editMode
                  ? { display: "none" }
                  : { marginRight: ".25em", float: "right" }
              }
              icon="pi pi-external-link"
              onClick={this.props.export}
            ></pr.Button>
            <pr.Button
              type="button"
              style={
                this.props.editMode
                  ? { display: "none" }
                  : { marginRight: ".25em", float: "right" }
              }
              icon={
                this.props.loading === false
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-refresh"
              }
              onClick={this.props.refresh}
            ></pr.Button>
            {this.props.runCrudOverride ? (
              <label></label>
            ) : (
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === false
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                onClick={() => {
                  this.props.addMode === true
                    ? this.props.runCrud(true)
                    : this.props.runCrud(false);
                }}
                style={
                  this.props.editMode
                    ? { marginRight: ".25em", float: "right" }
                    : { display: "none" }
                }
              />
            )}
          </div>
        </pr.Toolbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/BPMToolbar.js